import React from 'react'
import Dialog from '@mui/material/Dialog/Dialog'
import DialogContent from '@mui/material/DialogContent/DialogContent'
import DialogActions from '@mui/material/DialogActions/DialogActions'
import { prop } from 'ramda'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid'
import { dialogClasses, styled } from '@mui/material'
import Box from '@mui/material/Box'

import { Button } from '~/components/Buttons'
import Divider from '~/components/Divider'
import Avatar from '~/components/Avatar'
import DiscardButton from '~/components/Buttons/DiscardButton'
import { withForm } from '~/components/Form'
import DimensionField from '~/components/Fields/DimensionField'
import WeightField from '~/components/Fields/WeightField'

const DialogNameBoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '10px',
  justifyContent: 'space-between',
  '& span:first-of-type': {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '16px'
  },
  '& span:last-child': {
    color: 'rgba(39, 50, 87, 0.7)',
    fontSize: '12px'
  }
})

const DialogStyled = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: '910px'
  },
})

function ItemDimensionsEdit ({ open, onClose, variant, isLoading, ...props }) {
  const { form } = props

  const image = prop('defaultImage', variant)
  const variantName = prop('name', variant)
  const barcode = prop('barcode', variant)
  const handleSubmit = prop('handleSubmit', form)

  return (
    <DialogStyled
      open={open}
      onClose={onClose}
      fullWidth={true}
    >
      <Box display="flex" p={3}>
        <Avatar
          alt="dimension-edit"
          src={image}
        />
        <DialogNameBoxStyled>
          <span>{variantName}</span>
          <span>{barcode}</span>
        </DialogNameBoxStyled>
      </Box>
      <Divider />
      <DialogContent>
        <Grid container={true} spacing={2}>
          <Grid item={true} xs={6}>
            <DimensionField
              data-cy="width"
              name="width"
              label="Width"
            />
          </Grid>
          <Grid item={true} xs={6}>
            <DimensionField
              data-cy="height"
              name="height"
              label="Height"
            />
          </Grid>
          <Grid item={true} xs={6}>
            <DimensionField
              data-cy="length"
              name="length"
              label="Length"
            />
          </Grid>
          <Grid item={true} xs={6}>
            <WeightField
              data-cy="weight"
              name="weight"
              label="Weight"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <DiscardButton onClick={onClose} />
        <Button
          variant="contained"
          type="button"
          onClick={handleSubmit}
          disabled={isLoading}
          data-cy="dimensionSave"
        >
          Save
        </Button>
      </DialogActions>
    </DialogStyled>
  )
}

ItemDimensionsEdit.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  variant: PropTypes.object,
  form: PropTypes.object,
  isLoading: PropTypes.bool,
}

export default withForm(ItemDimensionsEdit)
